import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { Note } from "../../../Pages/UserVideoLessonDetail/ILessonsList";

type IVideoLesson = Note;

const initialState: IReduxState<IVideoLesson> = {
  data: {} as IVideoLesson,
  isLoading: false,
};

export const DeleteNoteVideoLessonsSlice = createSlice({
  name: "DeleteNoteVideoLessonsSlice",
  initialState,
  reducers: {
    // ✅ Do not store the payload (to avoid serializing File objects)
    DeleteNoteVideoLesson: (state, _action: PayloadAction<IVideoLesson>) => {
      state.isLoading = true;
    },

    successDeleteNoteVideoLessons: (
      state,
      action: PayloadAction<IVideoLesson>
    ) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureDeleteNoteVideoLessons: (state, action: PayloadAction<any>) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearDeleteNoteVideoLessonsResponse: (state) => {
      state.data = {} as IVideoLesson;
    },
  },
});

export const {
  DeleteNoteVideoLesson,
  successDeleteNoteVideoLessons,
  failureDeleteNoteVideoLessons,
  clearDeleteNoteVideoLessonsResponse,
} = DeleteNoteVideoLessonsSlice.actions;

export default DeleteNoteVideoLessonsSlice.reducer;
